import { Logo } from '@components/features/Layout/Navigation/Logo';

import css from './styles.module.css';

export function ShimmerLogo() {
  return (
    <span className={css.wrapper} aria-hidden>
      <Logo className={css.logo} />
    </span>
  );
}
